import { Suspense, type ReactNode } from "react"
import { PagePreloader } from "@/components/page-preloader"
import { DashboardSkeleton } from "@/components/dashboard-skeleton"
import {
  AppBootstrapLoader,
  ContentAreaLoader,
} from "@/components/loaders/preloader"

export type LazyFallback =
  | "list"
  | "detail"
  | "form"
  | "dashboard"
  | "none"
  | "bootstrap"

function getFallbackElement(fallback: LazyFallback) {
  switch (fallback) {
    case "list":
      return <PagePreloader variant="list" />
    case "detail":
      return <PagePreloader variant="detail" />
    case "form":
      return <PagePreloader variant="form" />
    case "dashboard":
      return <DashboardSkeleton />
    case "bootstrap":
      return <AppBootstrapLoader />
    case "none":
    default:
      return <ContentAreaLoader />
  }
}

export function LazyPage({
  fallback = "list",
  children,
}: {
  fallback?: LazyFallback
  children: ReactNode
}) {
  return (
    <Suspense fallback={getFallbackElement(fallback)}>{children}</Suspense>
  )
}
